module.exports = __webpack_public_path__ + "static/img/ic_check@2x.16bf277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_check@2x.png
// module id = jK/U
// module chunks = 10